import {SubmitButton} from "../input/submitButton";
import React, {useEffect, useState} from "react";
import {useGlobalContext, useUserContext} from "../../hooks/globalContext";
import {InputText} from "../input/inputText";
import {OneVision} from "../../models/payments/oneVision";
import {ReactComponent as DeleteSVG} from '../../resourse/img/general/ic-trash.svg';
import {FormWithLoader} from "../loader/formWithLoader";
import {RouteNames} from "../../migration/pages";

export function PaySagePaymentModule() {
    const {i18n, api} = useGlobalContext()
    const {user} = useUserContext()
    const [oneVision, setOneVision] = useState<OneVision>({orgId: "", apiKey: "", encryptedSecretKey: ""})
    const [secretKey, setSecretKey] = useState<string>("")

    const [loading, setLoading] = useState<boolean>(false)
    const [encryptionLoading, setEncryptionLoading] = useState<boolean>(false)
    const [saveLoading, setSaveLoading] = useState<boolean>(false)
    useEffect(() => {
        const controller = new AbortController()
        if (user?.org) {
            api.getPaySageSettings({setLoading: setLoading, controller}, user?.org.id).then((res) => {
                if (res.data && user?.org?.id) {
                    setOneVision({
                        orgId: user?.org.id,
                        apiKey: res.data?.apiKey,
                        encryptedSecretKey: res.data?.encryptedSecretKey
                    })
                }
            })
        }
        return () => controller.abort()
    }, [user?.org])

    function encryptSecretKey() {
        api.encodePaymentKeyPaySage({setLoading: setEncryptionLoading}, secretKey).then((res) => {
            if (res.data) {
                setOneVision({...oneVision, encryptedSecretKey: res.data.encryptedSecretKey})
            }
        })
    }

    function onChangeApiKey(v: string) {
        setOneVision({...oneVision, apiKey: v})
    }

    function onRemoveEncryptionKey() {
        setOneVision({...oneVision, encryptedSecretKey: ""})
    }

    function onSave() {
        api.savePaySageSettings({setLoading: setSaveLoading}, oneVision)
    }

    return (
        <FormWithLoader isloading={loading} className="form">
            <InputText label={i18n.api_key()} value={oneVision.apiKey} onChange={onChangeApiKey} isValidate={true}/>
            {oneVision.encryptedSecretKey === "" ?
                <InputText label={i18n.secret_key()} value={secretKey} onChange={setSecretKey} isValidate={true}/>
                :
                <div className="control">
                    <label className="control__label">{i18n.encrypted_key()}</label>
                    <div className={"iiko_Tag"}>
                        <div className={"control__input"}
                             style={{
                                 display: "flex",
                                 alignItems: "center",
                                 textOverflow: "clip",
                                 overflow: "hidden"
                             }}>{oneVision.encryptedSecretKey}</div>
                        <DeleteSVG onClick={onRemoveEncryptionKey}/>
                    </div>
                </div>
            }
            <div className="form__buttons mt-4">
                <div className="form__buttons-left">
                    {oneVision.encryptedSecretKey === "" ?
                        <SubmitButton onSubmit={encryptSecretKey} label={i18n.encode()}
                                      disabled={false} isLoading={encryptionLoading}
                                      modal={true}/>
                        :
                        <SubmitButton onSubmit={onSave} label={i18n.save()}
                                      disabled={false} isLoading={saveLoading}
                                      modal={true}/>
                    }
                    <a href={RouteNames.SETTINGS} className="button -bordered_blue form__button">
                        {i18n.cancel()}
                    </a>
                </div>
            </div>
        </FormWithLoader>
    )
}
